export default __webpack_public_path__ + "static/media/42.663dff09.jpg";